import React, { useEffect } from 'react';
import { Empty, Spin, Table, } from "antd";
import { useState } from "react";
import urls from "../../../http/endpoints/urls";
import { getRequest } from "../../../http/axiosConfig/config";
import moment from "moment";
import Swal from 'sweetalert2';



export default function OldPayments() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [paymentTimeVimul, setPaymentTimeVimul] = useState([]);
  // const creditLimit = JSON.parse(sessionStorage.getItem("creditLimit"));

  const columns = [
    {
      title: "Indent Date", dataIndex: "GP_DATE", width: 40,
    },
    { title: "Route name", dataIndex: "ROUTE_NAME", width: 30 },
    {
      title: "Amount",
      dataIndex: "TOTAL",
      width: 35,
      render: (text) => `Rs ${text}`  // Render function to prepend "Rs" to the amount
    },
    { title: "Route Code", dataIndex: "ROUTE_CODE", width: 35, hidden: true },
    { title: "Indent Number", dataIndex: "INDENT_NUMBER", width: 35, hidden: true },
    {
      title: "Action",
      dataIndex: "Action",
      width: 25,
      render: (text, record) => (
        <button
          style={{
            backgroundColor: "#23b0fc",
            color: "white",
            border: "none",
            padding: "5px 8px",
            width: "80%",
            borderRadius: "4px",
            margin: "5px 5px",
          }}
          onClick={() => { handlepayButtonClick(record) }}
        >
          Pay
        </button>
      ),
    }
  ].filter(item => !item.hidden);

  const handlepayButtonClick = (record) => {
    let isBetween = moment().isBetween(
      moment(paymentTimeVimul.ST_TIME, "hh.mm A"),
      moment(paymentTimeVimul.END_TIME, "hh.mm A"),
      "minutes"
    );
    if (!isBetween) {
      Swal.fire('Warning', `${paymentTimeVimul.MSG}`, 'warning');
      return
    }
    const now = new Date();
    // Format parts
    const dd = String(now.getDate()).padStart(2, "0");
    const mm = String(now.getMonth() + 1).padStart(2, "0"); // months start from 0
    const yyyy = now.getFullYear();

    const hh = String(now.getHours()).padStart(2, "0");
    const min = String(now.getMinutes()).padStart(2, "0");
    const sec = String(now.getSeconds()).padStart(2, "0");
    const ms = String(now.getMilliseconds()).padStart(3, "0");
    // Final timestamp format: DDMMYYYYHHMMSSMS 14 01 2026 16 49 08 503
    const timestamp = `${dd}${mm}${yyyy}${hh}${min}${sec}${ms}`;
    const customerCode = localStorage.getItem("userId");
    const usersCode = localStorage.getItem("agentCode");

    const payment_details = {
      customer_code: customerCode,
      users_code: usersCode,
      route_code: record.ROUTE_CODE,
      order_id: `Ord-${customerCode}-${usersCode}-${timestamp}`,
      amount: record.TOTAL,
      indent_number: record.INDENT_NUMBER,
      gp_date: record.GP_DATE,
      pay_type: "R",
      type:"payment_gateway"
    };
    window.ReactNativeWebView.postMessage(JSON.stringify(payment_details));
  }


  const getPaymentTime = async () => {
    try {
      const PaymentTime = await getRequest(urls.paymentTime());
      setPaymentTimeVimul(PaymentTime[0]);
    } catch (error) {
      console.log(error);
    }
  }

  const getOldPaymentList = async () => {
    setLoading(true)
    try {
      const res = await getRequest(
        urls.getOldBalance(localStorage.getItem("userId"))
      );
      const rowsWithId = res.map((item, index) => ({
        id: index + 1,   // unique ID
        ...item
      }));

      setRows(rowsWithId);
      setLoading(false)
    } catch (error) {
      console.log(error);
      setLoading(false)
    }
  }
  useEffect(() => {
    getOldPaymentList()
    getPaymentTime()
  }, [])
  return (
    <>
      <div>
        <div className="page-header">Payments not done list</div>
      </div>
      <Table
        dataSource={rows}
        locale={{
          emptyText: loading ? <Spin /> : <Empty />,
        }}
        key={rows.id}
        columns={columns}
        scroll={{ y: "calc(100vh - 350px)", x: 100 }}
        pagination={false}
        style={{ border: "1px solid black", borderRight: "2px solid black", }}
      />
    </>
  )
}




